<template>
  <div id="ApptCall" class="p-3 rounded-lg mb-2 bg-white text-black border-current shadow-2xl">
    <div class="loading" v-if="!room">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <div v-else>
      <div class="row">
        <div v-if="!showVideo" class="fs-20 fw-500">
          <span class="mr-1">Video Call</span>
          <svg
            class="cursor-pointer text-blue-700"
            @click="handleConnect"
            width="29"
            height="29"
            viewBox="0 0 29 29"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M24.7971 7.69833C24.3188 7.44167 23.3154 7.17333 21.9504 8.13L20.2354 9.34333C20.1071 5.715 18.5321 4.29167 14.7054 4.29167H7.70542C3.71542 4.29167 2.16376 5.84333 2.16376 9.83333V19.1667C2.16376 21.85 3.62209 24.7083 7.70542 24.7083H14.7054C18.5321 24.7083 20.1071 23.285 20.2354 19.6567L21.9504 20.87C22.6738 21.3833 23.3038 21.5467 23.8054 21.5467C24.2371 21.5467 24.5754 21.4183 24.7971 21.3017C25.2754 21.0567 26.0804 20.3917 26.0804 18.7233V10.2767C26.0804 8.60833 25.2754 7.94333 24.7971 7.69833ZM12.9554 13.7767C11.7538 13.7767 10.7621 12.7967 10.7621 11.5833C10.7621 10.37 11.7538 9.39 12.9554 9.39C14.1571 9.39 15.1488 10.37 15.1488 11.5833C15.1488 12.7967 14.1571 13.7767 12.9554 13.7767Z"
              fill="#20419B"
            />
          </svg>
          <!-- <span v-if="!logEnd">
            <span class="fs-18 fw-700 mx-2.5">Video call:</span>
            {{formatTime(total_time)}}
          </span>
          <span v-else>
            <span class="fs-18 fw-700 mx-2.5">Phiên tư vấn đã diễn ra trong</span>
            {{formatTime(logEnd.answer_duration)}}
          </span>-->
        </div>
        <div
          v-loading="isLoading"
          v-else
          class="appt-media-wraper"
          :class="isFullScreen?'showFullScreen':''"
        >
          <div
            class="main-media"
            :class="{'media-fullscreen':isFullScreen}"
            @keydown.esc="handleShowFullScreen(false)"
            tabindex="-1"
          >
            <Participant
              :participant="mainParticipantsTrack"
              v-if="mainParticipantsTrack"
              :tracks="mainParticipantsTrack.tracks"
            />
            <div class="bottom-action mt-3">
              <!-- mic -->
              <button
                @click.prevent="micChangeStatus()"
                class="ml-3 w-8 h-8 rounded-full border-0 focus:outline-none"
                :class="
                mic_status && has_audio ? 'bg-blue-50' : 'bg-blue-100'
              "
                :disabled="!has_audio || !room || changing_mic"
              >
                <svg
                  v-if="mic_status && has_audio"
                  width="20"
                  height="20"
                  viewBox="0 0 29 28"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M22.9287 10.64C22.4737 10.64 22.1121 11.0017 22.1121 11.4567V13.3C22.1121 17.43 18.7521 20.79 14.6221 20.79C10.4921 20.79 7.13205 17.43 7.13205 13.3V11.445C7.13205 10.99 6.77039 10.6284 6.31539 10.6284C5.86039 10.6284 5.49872 10.99 5.49872 11.445V13.2884C5.49872 18.0367 9.15039 21.945 13.8054 22.365V24.85C13.8054 25.305 14.1671 25.6667 14.6221 25.6667C15.0771 25.6667 15.4387 25.305 15.4387 24.85V22.365C20.0821 21.9567 23.7454 18.0367 23.7454 13.2884V11.445C23.7337 11.0017 23.3721 10.64 22.9287 10.64Z"
                    fill="#20419B"
                  />
                  <path
                    d="M14.6221 2.33331C11.7754 2.33331 9.46539 4.64331 9.46539 7.48998V13.4633C9.46539 16.31 11.7754 18.62 14.6221 18.62C17.4687 18.62 19.7787 16.31 19.7787 13.4633V7.48998C19.7787 4.64331 17.4687 2.33331 14.6221 2.33331ZM16.1504 10.4416C16.0687 10.745 15.8004 10.9433 15.4971 10.9433C15.4387 10.9433 15.3804 10.9316 15.3221 10.92C14.8671 10.7916 14.3887 10.7916 13.9337 10.92C13.5604 11.025 13.1987 10.8033 13.1054 10.4416C13.0004 10.08 13.2221 9.70665 13.5837 9.61331C14.2721 9.42665 14.9954 9.42665 15.6837 9.61331C16.0337 9.70665 16.2437 10.08 16.1504 10.4416ZM16.7687 8.17831C16.6637 8.45831 16.4071 8.62165 16.1271 8.62165C16.0454 8.62165 15.9754 8.60998 15.8937 8.58665C15.0771 8.28331 14.1671 8.28331 13.3504 8.58665C13.0004 8.71498 12.6037 8.52831 12.4754 8.17831C12.3471 7.82831 12.5337 7.43165 12.8837 7.31498C14.0037 6.90665 15.2404 6.90665 16.3604 7.31498C16.7104 7.44331 16.8971 7.82831 16.7687 8.17831Z"
                    fill="#20419B"
                  />
                </svg>

                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  v-if="!mic_status || !has_audio"
                >
                  <path
                    d="M21.8934 8.56002V10.1067L12.1867 19.8134C10.9067 18.6534 10.1067 16.9467 10.1067 15.12V8.56002C10.1067 5.81335 11.9734 3.53335 14.5067 2.88002C14.76 2.81335 15 3.02669 15 3.28002V5.33335C15 5.88002 15.4534 6.33335 16 6.33335C16.5467 6.33335 17 5.88002 17 5.33335V3.28002C17 3.02669 17.24 2.81335 17.4934 2.88002C20.0267 3.53335 21.8934 5.81335 21.8934 8.56002Z"
                    fill="#20419B"
                  />
                  <path
                    d="M26.4134 13.0799V15.1999C26.4134 20.6266 22.2401 25.0932 16.9334 25.5599V28.3999C16.9334 28.9199 16.5201 29.3332 16.0001 29.3332C15.4801 29.3332 15.0668 28.9199 15.0668 28.3999V25.5599C13.6134 25.4266 12.2401 24.9999 11.0134 24.3199L12.3868 22.9466C13.4801 23.4532 14.7068 23.7466 16.0001 23.7466C20.7201 23.7466 24.5601 19.9066 24.5601 15.1999V13.0799C24.5601 12.5732 24.9734 12.1599 25.4934 12.1599C26.0001 12.1599 26.4134 12.5732 26.4134 13.0799Z"
                    fill="#20419B"
                  />
                  <path
                    d="M21.8934 13.4399V15.3733C21.8934 18.8133 18.9334 21.5733 15.4134 21.2399C15.0401 21.1999 14.6667 21.1333 14.3201 21.0133L21.8934 13.4399Z"
                    fill="#20419B"
                  />
                  <path
                    d="M29.0266 2.97334C28.6266 2.57334 27.9732 2.57334 27.5732 2.97334L9.63991 20.9067C8.26658 19.4 7.43991 17.4 7.43991 15.2V13.08C7.43991 12.5733 7.02658 12.16 6.50658 12.16C5.99991 12.16 5.58658 12.5733 5.58658 13.08V15.2C5.58658 17.9067 6.62658 20.3733 8.31991 22.2267L2.95991 27.5867C2.55991 27.9867 2.55991 28.64 2.95991 29.04C3.17325 29.2267 3.42658 29.3333 3.69325 29.3333C3.95991 29.3333 4.21325 29.2267 4.41325 29.0267L29.0266 4.41334C29.4399 4.01334 29.4399 3.37334 29.0266 2.97334Z"
                    fill="#20419B"
                  />
                </svg>
              </button>
              <!-- mic -->

              <!-- camera -->
              <button
                @click.prevent="camChangeStatus()"
                class="ml-3 w-8 h-8 rounded-full border-0 focus:outline-none"
                :class="
                cam_status && has_video ? 'bg-blue-50' : 'bg-blue-100'
              "
                :disabled="!has_video || !room || changing_cam"
              >
                <svg
                  v-if="cam_status && has_video"
                  width="20"
                  height="20"
                  viewBox="0 0 29 28"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M24.7971 7.19829C24.3188 6.94163 23.3154 6.67329 21.9504 7.62996L20.2354 8.84329C20.1071 5.21496 18.5321 3.79163 14.7054 3.79163H7.70542C3.71542 3.79163 2.16376 5.34329 2.16376 9.33329V18.6666C2.16376 21.35 3.62209 24.2083 7.70542 24.2083H14.7054C18.5321 24.2083 20.1071 22.785 20.2354 19.1566L21.9504 20.37C22.6738 20.8833 23.3038 21.0466 23.8054 21.0466C24.2371 21.0466 24.5754 20.9183 24.7971 20.8016C25.2754 20.5566 26.0804 19.8916 26.0804 18.2233V9.77663C26.0804 8.10829 25.2754 7.44329 24.7971 7.19829ZM12.9554 13.2766C11.7538 13.2766 10.7621 12.2966 10.7621 11.0833C10.7621 9.86996 11.7538 8.88996 12.9554 8.88996C14.1571 8.88996 15.1488 9.86996 15.1488 11.0833C15.1488 12.2966 14.1571 13.2766 12.9554 13.2766Z"
                    fill="#20419B"
                  />
                </svg>

                <svg
                  v-if="!cam_status || !has_video"
                  width="20"
                  height="20"
                  viewBox="0 0 25 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    opacity="0.4"
                    d="M18.3621 7.57001C18.3721 7.64001 18.3721 7.72001 18.3621 7.79001C18.3621 7.72001 18.3521 7.65001 18.3521 7.58001L18.3621 7.57001Z"
                    fill="#20419B"
                  />
                  <path
                    d="M17.9021 6.56L4.45208 20.01C3.05208 19.12 2.50208 17.53 2.50208 16V8C2.50208 4.58 3.83208 3.25 7.25208 3.25H13.2521C16.1421 3.25 17.5321 4.2 17.9021 6.56Z"
                    fill="#20419B"
                  />
                  <path
                    d="M22.0221 2.23C21.7221 1.93 21.2321 1.93 20.9321 2.23L2.47207 20.69C2.17207 20.99 2.17207 21.48 2.47207 21.78C2.62207 21.92 2.82207 22 3.01207 22C3.21207 22 3.40207 21.92 3.55207 21.77L22.0221 3.31C22.3221 3.01 22.3221 2.53 22.0221 2.23Z"
                    fill="#20419B"
                  />
                  <path
                    d="M23.0021 8.37998V15.62C23.0021 17.05 22.3021 17.62 21.9021 17.83C21.7121 17.93 21.4121 18.04 21.0421 18.04C20.6121 18.04 20.0821 17.9 19.4621 17.46L17.9821 16.42C17.9121 18.63 17.2121 19.89 15.6221 20.42C14.9821 20.65 14.1921 20.75 13.2421 20.75H7.2421C7.0021 20.75 6.7721 20.74 6.5321 20.71L15.6221 11.63L21.2721 5.97998C21.5321 5.99998 21.7421 6.07998 21.9021 6.16998C22.3021 6.37998 23.0021 6.94998 23.0021 8.37998Z"
                    fill="#20419B"
                  />
                </svg>
              </button>
              <button
                @click.prevent="onDisconect"
                class="ml-3 w-8 h-8 rounded-full border-0 focus:outline-none bg-danger"
              >
                <svg
                  style="margin-top:2px"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19.8501 5.56004L21.6401 3.77004C21.7448 3.68039 21.8298 3.57008 21.8898 3.44601C21.9499 3.32195 21.9836 3.18681 21.9889 3.0491C21.9942 2.91138 21.971 2.77404 21.9207 2.64572C21.8705 2.51739 21.7942 2.40085 21.6968 2.30339C21.5993 2.20594 21.4827 2.12968 21.3544 2.0794C21.2261 2.02913 21.0888 2.00592 20.951 2.01124C20.8133 2.01656 20.6782 2.05029 20.5541 2.11032C20.4301 2.17034 20.3197 2.25536 20.2301 2.36004L18.4401 4.15004L16.6401 2.36004C16.4488 2.19622 16.2027 2.11061 15.951 2.12033C15.6994 2.13005 15.4606 2.23438 15.2825 2.41248C15.1044 2.59057 15.0001 2.82931 14.9904 3.08099C14.9807 3.33266 15.0663 3.57874 15.2301 3.77004L17.0001 5.56004L15.2101 7.36004C15.0239 7.5474 14.9193 7.80086 14.9193 8.06504C14.9193 8.32923 15.0239 8.58268 15.2101 8.77004C15.3975 8.95629 15.6509 9.06083 15.9151 9.06083C16.1793 9.06083 16.4327 8.95629 16.6201 8.77004L18.4401 7.00004L20.2301 8.79004C20.4175 8.97629 20.6709 9.08083 20.9351 9.08083C21.1993 9.08083 21.4527 8.97629 21.6401 8.79004C21.8264 8.60268 21.9309 8.34923 21.9309 8.08504C21.9309 7.82086 21.8264 7.5674 21.6401 7.38004L19.8501 5.56004ZM19.4401 13C19.2201 13 18.9901 12.93 18.7701 12.88C18.3246 12.7819 17.8868 12.6515 17.4601 12.49C16.9962 12.3213 16.4862 12.33 16.0284 12.5146C15.5706 12.6993 15.1972 13.0467 14.9801 13.49L14.7601 13.94C13.7861 13.3982 12.8911 12.7253 12.1001 11.94C11.3149 11.1491 10.6419 10.254 10.1001 9.28004L10.5201 9.00004C10.9635 8.78296 11.3109 8.40957 11.4955 7.95173C11.6801 7.49389 11.6889 6.98395 11.5201 6.52004C11.3613 6.09246 11.231 5.65484 11.1301 5.21004C11.0801 4.99004 11.0401 4.76004 11.0101 4.53004C10.8887 3.82566 10.5197 3.18778 9.96972 2.73128C9.41972 2.27478 8.7248 2.02965 8.0101 2.04004H5.0101C4.57913 2.036 4.15235 2.12485 3.75881 2.30057C3.36527 2.47629 3.01421 2.73474 2.72953 3.05832C2.44485 3.38191 2.23324 3.76304 2.10909 4.17576C1.98494 4.58848 1.95118 5.0231 2.0101 5.45004C2.54284 9.63942 4.45613 13.5319 7.44775 16.5127C10.4394 19.4934 14.3388 21.3925 18.5301 21.91H18.9101C19.6475 21.9111 20.3595 21.6406 20.9101 21.15C21.2265 20.8671 21.4792 20.5202 21.6516 20.1324C21.8239 19.7445 21.9121 19.3245 21.9101 18.9V15.9C21.8979 15.2054 21.6449 14.5366 21.1944 14.0077C20.744 13.4788 20.1239 13.1227 19.4401 13ZM19.9401 19C19.9399 19.142 19.9095 19.2823 19.8509 19.4117C19.7923 19.541 19.7068 19.6563 19.6001 19.75C19.4884 19.8465 19.3577 19.9186 19.2165 19.9616C19.0753 20.0047 18.9267 20.0178 18.7801 20C15.035 19.5198 11.5563 17.8065 8.89282 15.1303C6.2293 12.4541 4.53251 8.96738 4.0701 5.22004C4.05419 5.07356 4.06813 4.92537 4.1111 4.78443C4.15407 4.64349 4.22517 4.51273 4.3201 4.40004C4.41381 4.29337 4.52916 4.20788 4.65848 4.14926C4.7878 4.09063 4.92812 4.06022 5.0701 4.06004H8.0701C8.30265 4.05487 8.52972 4.13092 8.71224 4.27511C8.89476 4.4193 9.02131 4.62261 9.0701 4.85004C9.1101 5.12337 9.1601 5.39337 9.2201 5.66004C9.33562 6.18719 9.48936 6.70522 9.6801 7.21004L8.2801 7.86004C8.1604 7.91496 8.05272 7.99299 7.96326 8.08964C7.87379 8.18629 7.8043 8.29966 7.75877 8.42324C7.71324 8.54682 7.69257 8.67817 7.69795 8.80976C7.70332 8.94135 7.73464 9.07059 7.7901 9.19004C9.2293 12.2728 11.7073 14.7508 14.7901 16.19C15.0336 16.2901 15.3066 16.2901 15.5501 16.19C15.6748 16.1454 15.7894 16.0765 15.8873 15.9872C15.9851 15.898 16.0643 15.7901 16.1201 15.67L16.7401 14.27C17.2571 14.4549 17.7847 14.6085 18.3201 14.73C18.5868 14.79 18.8568 14.84 19.1301 14.88C19.3575 14.9288 19.5608 15.0554 19.705 15.2379C19.8492 15.4204 19.9253 15.6475 19.9201 15.88L19.9401 19Z"
                    fill="white"
                  />
                </svg>
              </button>
            </div>
          </div>
          <div class="participant-media" :class="{'participant-fullscreen':isFullScreen}">
            <div
              v-for="(participant, i) in participantsTracks"
              :key="participant.id + 'mini-participant' + i"
              class="participant-media-item"
            >
              <Participant
                @zoomTrack="zoomPTrack"
                :participant="participant"
                :tracks="participant.tracks"
                :key="participant.id + 'mini-participant' + i + 'p-cpn'"
              />
            </div>
          </div>
          <div v-if="isFullScreen" @click="handleShowFullScreen(false)" class="icon-fullscreen">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16 9H21C21.2652 9 21.5196 8.89464 21.7071 8.70711C21.8946 8.51957 22 8.26522 22 8C22 7.73478 21.8946 7.48043 21.7071 7.29289C21.5196 7.10536 21.2652 7 21 7H17V3C17 2.73478 16.8946 2.48043 16.7071 2.29289C16.5196 2.10536 16.2652 2 16 2C15.7348 2 15.4804 2.10536 15.2929 2.29289C15.1054 2.48043 15 2.73478 15 3V8C15 8.26522 15.1054 8.51957 15.2929 8.70711C15.4804 8.89464 15.7348 9 16 9ZM8 15H3C2.73478 15 2.48043 15.1054 2.29289 15.2929C2.10536 15.4804 2 15.7348 2 16C2 16.2652 2.10536 16.5196 2.29289 16.7071C2.48043 16.8946 2.73478 17 3 17H7V21C7 21.2652 7.10536 21.5196 7.29289 21.7071C7.48043 21.8946 7.73478 22 8 22C8.26522 22 8.51957 21.8946 8.70711 21.7071C8.89464 21.5196 9 21.2652 9 21V16C9 15.7348 8.89464 15.4804 8.70711 15.2929C8.51957 15.1054 8.26522 15 8 15ZM8 2C7.73478 2 7.48043 2.10536 7.29289 2.29289C7.10536 2.48043 7 2.73478 7 3V7H3C2.73478 7 2.48043 7.10536 2.29289 7.29289C2.10536 7.48043 2 7.73478 2 8C2 8.26522 2.10536 8.51957 2.29289 8.70711C2.48043 8.89464 2.73478 9 3 9H8C8.26522 9 8.51957 8.89464 8.70711 8.70711C8.89464 8.51957 9 8.26522 9 8V3C9 2.73478 8.89464 2.48043 8.70711 2.29289C8.51957 2.10536 8.26522 2 8 2ZM21 15H16C15.7348 15 15.4804 15.1054 15.2929 15.2929C15.1054 15.4804 15 15.7348 15 16V21C15 21.2652 15.1054 21.5196 15.2929 21.7071C15.4804 21.8946 15.7348 22 16 22C16.2652 22 16.5196 21.8946 16.7071 21.7071C16.8946 21.5196 17 21.2652 17 21V17H21C21.2652 17 21.5196 16.8946 21.7071 16.7071C21.8946 16.5196 22 16.2652 22 16C22 15.7348 21.8946 15.4804 21.7071 15.2929C21.5196 15.1054 21.2652 15 21 15Z"
                fill="white"
              />
            </svg>
          </div>
          <div v-else @click="handleShowFullScreen(true)" class="icon-fullscreen">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8 2H3C2.73478 2 2.48043 2.10536 2.29289 2.29289C2.10536 2.48043 2 2.73478 2 3V8C2 8.26522 2.10536 8.51957 2.29289 8.70711C2.48043 8.89464 2.73478 9 3 9C3.26522 9 3.51957 8.89464 3.70711 8.70711C3.89464 8.51957 4 8.26522 4 8V4H8C8.26522 4 8.51957 3.89464 8.70711 3.70711C8.89464 3.51957 9 3.26522 9 3C9 2.73478 8.89464 2.48043 8.70711 2.29289C8.51957 2.10536 8.26522 2 8 2ZM8 20H4V16C4 15.7348 3.89464 15.4804 3.70711 15.2929C3.51957 15.1054 3.26522 15 3 15C2.73478 15 2.48043 15.1054 2.29289 15.2929C2.10536 15.4804 2 15.7348 2 16V21C2 21.2652 2.10536 21.5196 2.29289 21.7071C2.48043 21.8946 2.73478 22 3 22H8C8.26522 22 8.51957 21.8946 8.70711 21.7071C8.89464 21.5196 9 21.2652 9 21C9 20.7348 8.89464 20.4804 8.70711 20.2929C8.51957 20.1054 8.26522 20 8 20ZM21 2H16C15.7348 2 15.4804 2.10536 15.2929 2.29289C15.1054 2.48043 15 2.73478 15 3C15 3.26522 15.1054 3.51957 15.2929 3.70711C15.4804 3.89464 15.7348 4 16 4H20V8C20 8.26522 20.1054 8.51957 20.2929 8.70711C20.4804 8.89464 20.7348 9 21 9C21.2652 9 21.5196 8.89464 21.7071 8.70711C21.8946 8.51957 22 8.26522 22 8V3C22 2.73478 21.8946 2.48043 21.7071 2.29289C21.5196 2.10536 21.2652 2 21 2ZM21 15C20.7348 15 20.4804 15.1054 20.2929 15.2929C20.1054 15.4804 20 15.7348 20 16V20H16C15.7348 20 15.4804 20.1054 15.2929 20.2929C15.1054 20.4804 15 20.7348 15 21C15 21.2652 15.1054 21.5196 15.2929 21.7071C15.4804 21.8946 15.7348 22 16 22H21C21.2652 22 21.5196 21.8946 21.7071 21.7071C21.8946 21.5196 22 21.2652 22 21V16C22 15.7348 21.8946 15.4804 21.7071 15.2929C21.5196 15.1054 21.2652 15 21 15Z"
                fill="white"
              />
            </svg>
          </div>
        </div>

        <!-- <template v-if="!logEnd">
          <div class="flex justify-between items-end mt-3">
            <div v-if="hasPdfFile" class="flex flex-col">
              <div class="fs-16 fw-400 text-black mr-7 font-bold-b">Đã có Phiếu Tư Vấn</div>
              <div
                class="flex items-center bg-save-file fs-14 fw-400 px-2 py-1 rounded-md cursor-pointer mt-1.5"
                @click="openPDF(consultation.pdf_file)"
              >
                <img
                  src="../../../public/assets/images/icon/pdf-icon.svg"
                  alt
                  width="24"
                  height="24"
                  class="mr-2"
                />
                <span class="robo-14-400 pt-1">Phiếu tư vấn {{formatD(consultation.created_at)}}</span>
              </div>
            </div>
            <div v-else class="fs-16 fw-400 text-black mr-7 font-bold-b">Chưa có Phiếu Tư Vấn</div>

            <div>
              <button
                class="btn bg-pri bd-pri text-white fs-14 fw-600 w-48 h-12"
                @click="onDisconect"
              >
                <span>Kết thúc Tư vấn</span>
              </button>
            </div>
          </div>
        </template>-->
      </div>
    </div>
    <!-- footer -->
    <div id="audio-wraper" class="d-none">
      <audio ref="audioJoin" id="signal-end" preload="auto">
        <source src="../../../public/assets/audio/Join.mp3" type="audio/mp3" />
      </audio>
      <audio ref="audioLeave" id="signal-end" preload="auto">
        <source src="../../../public/assets/audio/Out.mp3" type="audio/mp3" />
      </audio>
    </div>
  </div>
</template>

<script>
import appUtils from '../../utils/appUtils'
import Participant from '../../components/TwilioComponent/Participant.vue'
import LocalParticipantDiv from '../../components/TwilioComponent/LocalParticipant.vue'
import FormPhieuTuVan from '../../components/PhieuTuVan/FormPhieuTuVan.vue'

const {
  connect,
  createLocalVideoTrack,
  LocalVideoTrack,
  createLocalTracks,
  createLocalAudioTrack
} = require('twilio-video')
export default {
  name: 'OnlineRoomTemp',
  props: {
    patientVisit: Object
  },
  components: {
    Participant,
    LocalParticipantDiv,
    FormPhieuTuVan
  },
  data () {
    return {
      room: null,
      participantsTracks: [],
      mainParticipantsTrack: null,
      room_members: [],
      room_name: '',
      has_devices: [],
      doctor_id: null,
      is_support_browser: false,
      has_video: false,
      has_audio: false,
      mic_status: false,
      cam_status: false,
      token: null,
      screen_track: null,
      is_share_screen: false,
      total_time: 0,
      canShare: false,
      changing_mic: false,
      changing_cam: false,
      appointment: null,
      logStart: null,
      logEnd: null,
      saveFile: null,
      isFullScreen: false,
      showVideo: true,
      isLoading: false
    }
  },
  computed: {
    hasPdfFile () {
      return this.saveFile || this.appointment?.consultation?.pdf_file
    },
    consultation () {
      return this.saveFile || this.appointment?.consultation || {}
    }
  },
  watch: {},
  created () {
    // if (!this.patientVisit?.appt_id) return

    let self = this
    window.addEventListener('unload', function (e) {
      self.disconnect(e)
    })
  },
  mounted () {
    this.handleConnect()
  },
  methods: {
    async handleConnect () {
      if (!this.patientVisit?.appt_id) return
      this.showVideo = true
      this.isLoading = true
      let self = this
      this.doctor_id = this.$user.doctor.id
      self.has_devices = []
      if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
        alert(
          'HODO không hỗ trợ dịch vụ này trên trình duyệt hiện tại, vui lòng sử dụng một trong các trình duyệt: Chrome/Microsoft Edge/Firefox'
        )
        self.is_support_browser = false
        self.backToList()
        this.isLoading = false
      } else {
        self.is_support_browser = true
        await navigator.mediaDevices
          .enumerateDevices()
          .then(devices => {
            devices.forEach(device => {
              self.has_devices.push(device.kind)
            })
          })
          .then(async () => {
            self.has_video = !!self.has_devices.includes('videoinput')
            self.has_audio = !!self.has_devices.includes('audioinput')
            if (
              navigator.userAgent.search('Safari') >= 0 &&
              navigator.userAgent.search('Chrome') < 0
            ) {
            } else {
              await self.getAppts()
            }

            this.isLoading = false
          })
          .catch(function (err) {
            console.log(err.name + ': ' + err.message)
            this.isLoading = false
          })
      }
    },
    getMemberJoined () {
      return this.room?.participants?.size + 1 || 1
    },
    refresh () {
      this.getAppts(true)
    },
    async getAppts (refresh = false) {
      let self = this
      try {
        await self.$rf
          .getRequest('DoctorRequest')
          .getAppts(this.patientVisit?.appt_id)
          .then(async resp => {
            self.appointment = resp.data
            if (resp && resp.data && resp.data?.room_call?.room_name) {
              self.room_name = resp.data?.room_call?.room_name
              if (resp.data?.doctor?.user) {
                self.room_members.push(resp.data?.doctor?.user)
              }
              if (resp.data?.person?.user) {
                self.room_members.push(resp.data?.person?.user)
              }
              if (!refresh) {
                await self.getToken()
                await self.changeStatus(1)
              }
            } else {
              self.$router.push({ path: '/doctor/patient-visit' })
              self.$toast.open({
                message: 'Tham gia thất bại vui lòng thử lại sau',
                type: 'warning'
              })
            }
          })
      } catch (e) {
        // statements
        console.log(e)
      } finally {
        this.isLoading = false
      }
    },
    async changeStatus (stt) {
      if (!this.appointment?.consultation?.id) return
      await this.$rf
        .getRequest('DoctorRequest')
        .changeConsultationStatus(this.appointment.consultation.id, stt)
    },
    async getToken () {
      let self = this
      await self.$rf
        .getRequest('DoctorRequest')
        .getTwilioToken()
        .then(r => {
          if (r && r.data && r.data.token) self.token = r.data.token
        })
        .then(() => {
          self.connectRoom()
        })
    },
    connectRoom () {
      let self = this
      let options = {
        audio: false,
        video: false
        // logLevel: 'debug'
      }
      if (self.has_video) {
        options.video = { width: 720 }
        self.cam_status = true
      }
      if (self.has_audio) {
        options.audio = true
        self.mic_status = true
      }

      createLocalTracks(options)
        .then(localTracks => {
          return connect(self.token, {
            name: self.room_name,
            tracks: localTracks
          })
        })
        .then(async room => {
          self.room = room
          // call start
          // const params = {
          //   clinic_id: this.appointment.clinic_id,
          //   // person_diseases_id: this.appointment.person_diseases_id,
          //   appt_id: this.appointment.id,
          //   from_user_id: this.appointment.doctor.user_id,
          //   to_user_id: this.appointment.person?.user_id,
          //   is_videocall: self.has_video,
          //   start_time: new Date()
          // }
          // try {
          //   const data = await self.$rf
          //     .getRequest('DoctorRequest')
          //     .postTelemedicine(params)
          //   self.logStart = data.data
          //   if (self.logStart) {
          //     self.startTimeCount()
          //   }
          // } catch (error) {
          //   console.log(error)
          // }

          let pt = {
            id: room.localParticipant.sid,
            participant: room.localParticipant,
            tracks: self.getTrackDiffScreens(room.localParticipant),
            type: 'normal'
          }
          this.mainParticipantsTrack = pt

          console.log(`Successfully joined a Room: ${self.room}`)
          // Log new Participants as they connect to the Room
          self.room.once('participantConnected', participant => {
            console.log(
              `Participant "${participant.identity}" has connected to the Room`
            )
          })

          // Log Participants as they disconnect from the Room
          self.room.once('participantDisconnected', participant => {
            console.log(
              `Participant "${participant.identity}" has disconnected from the Room`
            )
          })

          // Remote tham gia phòng
          self.room.on('participantConnected', participant => {
            console.log(`Participant connected: ${participant.identity}`)
            try {
              self.$refs.audioJoin.play()
            } catch (e) {
              console.log(e)
            }
            self.createParticipantsTracks(participant)
            // thêm video/track các remote tham gia
            participant.on('trackSubscribed', track => {
              self.trackSubscribed(track, participant)
            })
            // remove track
            participant.on('trackUnsubscribed', track => {
              self.trackUnsubscribed(track, participant)
            })
            participant.on('trackDisabled', track => {
              console.log(track)
            })
          })

          self.room.on('participantDisconnected', participant => {
            console.log(`Participant disconnected: ${participant.identity}`)
            // self.getTracks(participant).forEach(function (track) {
            //   track.detach().forEach(function (element) {
            //     element.srcObject = null
            //     element.remove()
            //   })
            // })
            try {
              self.$refs.audioLeave.play()
            } catch (e) {
              console.log(e)
            }
            self.removeParticipant(participant)
          })

          // Thêm các video/track remote đã có trong phòng
          self.room.participants.forEach(participant => {
            console.log(`Participant connected: ${participant.identity}`)
            // add khi có thêm track mới

            self.createParticipantsTracks(participant)
            // thêm video/track các remote tham gia
            participant.on('trackSubscribed', track => {
              self.trackSubscribed(track, participant)
            })
            // remove track
            participant.on('trackUnsubscribed', track => {
              self.trackUnsubscribed(track, participant)
            })
            participant.on('trackDisabled', track => {
              console.log(track)
            })
          })
        })
        .catch(error => {
          console.error(`Unable to connect to Room: ${error.message}`)
          if (error.message === 'Permission denied') {
            self.$toast.open({
              message: self.$t(
                'Vui lòng cấp quyền truy cập máy ảnh và micro để tham gia phòng khám'
              ),
              type: 'warning'
            })
          } else {
            self.$toast.open({
              message: self.$t('Tham gia thất bại vui lòng thử lại sau'),
              type: 'warning'
            })
          }

          self.backToList()
        })
    },
    async disconnect (isNotExits) {
      let self = this
      this.changeStatus(2)
      this.stopTimeCount()
      if (!this.room) return

      // end
      // const params = {
      //   ...this.logStart,
      //   end_time: new Date()
      // }
      // try {
      //   const data = await self.$rf
      //     .getRequest('DoctorRequest')
      //     .putTelemedicine(params.id, params)
      //   self.logEnd = data.data
      // } catch (error) {
      //   console.log(error)
      // }
      this.room.on('disconnected', room => {
        // Detach the local media elements
        this.room.localParticipant.tracks.forEach(publication => {
          const attachedElements = publication.track.detach()
          publication.unpublish()
          publication.track.stop()
          attachedElements.forEach(element => element.remove())
          publication.track.disable()
        })
        if (self.screen_track) {
          self.room.localParticipant.unpublishTrack(self.screen_track)
          self.screen_track.stop()
        }
      })
      this.room.disconnect()
      this.mainParticipantsTrack = null
      this.participantsTracks = []
      if (isNotExits) return
      setTimeout(() => {
        this.backToList()
      }, 300)
    },
    onDisconect () {
      let r = confirm('Bác sĩ muốn kết thúc cuộc gọi?')
      if (!r) return
      this.showVideo = false
      this.isFullScreen = false
      this.disconnect(true)
    },
    backToList () {
      this.$router
        .push({
          name: 'PatientVisitManagement'
          // params: { id: this.$route.params.id }
        })
        .catch(() => {})
    },
    micChangeStatus () {
      if (this.changing_mic) return
      this.changing_mic = true
      this.mic_status ? this.muteMic() : this.unmuteMic()
      this.mic_status = !this.mic_status
    },
    camChangeStatus () {
      if (this.changing_cam) return
      this.changing_cam = true
      this.cam_status ? this.disableVideo() : this.enableVideo()
      this.cam_status = !this.cam_status
    },
    muteMic () {
      const self = this
      try {
        this.room.localParticipant.audioTracks.forEach(publication => {
          publication.unpublish()
          publication.track.stop()
          if (
            self.mainParticipantsTrack.id === self.room.localParticipant.sid
          ) {
            const pt = {
              id: self.room.localParticipant.sid,
              participant: self.room.localParticipant,
              tracks: self.getTrackDiffScreens(self.room.localParticipant),
              type: 'normal'
            }
            self.mainParticipantsTrack = pt
          } else {
            const lcP = self.participantsTracks.findIndex(
              p => p.id === self.room.localParticipant.sid
            )
            if (lcP > -1) {
              self.participantsTracks[lcP] = {
                id: self.room.localParticipant.sid,
                participant: self.room.localParticipant,
                tracks: self.getTrackDiffScreens(self.room.localParticipant),
                type: 'normal'
              }
            }
          }
        })
      } catch (error) {
        console.log(error)
      } finally {
        this.changing_mic = false
      }
    },
    unmuteMic () {
      this.createAudioTrack()
    },
    disableVideo () {
      const self = this
      try {
        this.room.localParticipant.videoTracks.forEach(publication => {
          if (
            publication.track.name !==
            'screen' + self.room.localParticipant.sid
          ) {
            publication.unpublish()
            publication.track.stop()
            if (
              self.mainParticipantsTrack.id === self.room.localParticipant.sid
            ) {
              const pt = {
                id: self.room.localParticipant.sid,
                participant: self.room.localParticipant,
                tracks: self.getTrackDiffScreens(self.room.localParticipant),
                type: 'normal'
              }
              self.mainParticipantsTrack = pt
            } else {
              const lcP = self.participantsTracks.findIndex(
                p => p.id === self.room.localParticipant.sid
              )
              if (lcP > -1) {
                self.participantsTracks[lcP] = {
                  id: self.room.localParticipant.sid,
                  participant: self.room.localParticipant,
                  tracks: self.getTrackDiffScreens(self.room.localParticipant),
                  type: 'normal'
                }
              }
            }
          }
        })
      } catch (error) {
        console.log(error)
      } finally {
        this.changing_cam = false
      }
    },
    enableVideo () {
      this.createVideoTrack()
    },
    createAudioTrack () {
      const self = this
      if (self.has_audio) {
        createLocalAudioTrack().then(audio => {
          self.room.localParticipant
            .publishTrack(audio)
            .then(() => {
              if (
                self.mainParticipantsTrack.id === self.room.localParticipant.sid
              ) {
                const tracks = self.getTrackDiffScreens(
                  self.room.localParticipant
                )
                const pt = {
                  id: self.room.localParticipant.sid,
                  participant: self.room.localParticipant,
                  tracks: tracks,
                  type: 'normal'
                }
                self.mainParticipantsTrack = pt
              } else {
                const lcP = self.participantsTracks.findIndex(
                  p => p.id === self.room.localParticipant.sid
                )
                if (lcP > -1) {
                  self.participantsTracks[lcP] = {
                    id: self.room.localParticipant.sid,
                    participant: self.room.localParticipant,
                    tracks: self.getTrackDiffScreens(
                      self.room.localParticipant
                    ),
                    type: 'normal'
                  }
                }
              }
            })
            .then(() => {
              self.changing_mic = false
            })
        })
      }
    },
    createVideoTrack () {
      const self = this
      if (self.has_video) {
        createLocalVideoTrack().then(video => {
          self.room.localParticipant
            .publishTrack(video)
            .then(() => {
              if (
                self.mainParticipantsTrack.id === self.room.localParticipant.sid
              ) {
                const tracks = self.getTrackDiffScreens(
                  self.room.localParticipant
                )
                const pt = {
                  id: self.room.localParticipant.sid,
                  participant: self.room.localParticipant,
                  tracks: tracks,
                  type: 'normal'
                }
                self.mainParticipantsTrack = pt
              } else {
                const lcP = self.participantsTracks.findIndex(
                  p => p.id === self.room.localParticipant.sid
                )
                if (lcP > -1) {
                  self.participantsTracks[lcP] = {
                    id: self.room.localParticipant.sid,
                    participant: self.room.localParticipant,
                    tracks: self.getTrackDiffScreens(
                      self.room.localParticipant
                    ),
                    type: 'normal'
                  }
                }
              }
            })
            .then(() => {
              self.changing_cam = false
            })
        })
      }
    },
    getTracks (participant) {
      let self = this
      return Array.from(participant.tracks.values())
        .filter(function (publication) {
          if (self.isStreamTrack(publication.track)) return publication.track
        })
        .map(function (publication) {
          if (self.isStreamTrack(publication.track)) return publication.track
        })
    },
    getTrackDiffScreens (participant) {
      let self = this
      return Array.from(participant.tracks.values())
        .filter(function (publication) {
          if (
            !self.isScreen(publication.trackName) &&
            self.isStreamTrack(publication.track)
          ) {
            return publication.track
          }
        })
        .map(function (publication) {
          if (
            !self.isScreen(publication.trackName) &&
            self.isStreamTrack(publication.track)
          ) {
            return publication.track
          }
        })
    },

    isScreen (name) {
      return name?.includes('screen')
    },
    isStreamTrack (t) {
      return t?.kind === 'video' || t?.kind === 'audio'
    },
    async shareScreenHandler () {
      let self = this
      if (!self.screen_track) {
        let stream = await self.getUserScreen()
        if (!stream) return
        let screenName = 'screen' + self.room?.localParticipant?.sid
        self.screen_track = LocalVideoTrack(stream.getTracks()[0], {
          name: screenName
        })
        self.room.localParticipant.publishTrack(self.screen_track)
        self.is_share_screen = true
        self.screen_track.mediaStreamTrack.onended = () => {
          self.shareScreenHandler()
        }
        self.createLocalShare(self.screen_track)
      } else {
        if (
          this.mainParticipantsTrack &&
          this.mainParticipantsTrack.id ===
            'screen' + this.room.localParticipant.sid
        ) {
          this.setMeToMain()
        } else {
          let idxPt = this.participantsTracks.findIndex(
            pt => pt.type === 'screen' + this.room.localParticipant.sid
          )
          this.participantsTracks.splice(idxPt, 1)
        }
        self.room.localParticipant.unpublishTrack(self.screen_track)
        self.screen_track.stop()
        self.screen_track = null
        self.is_share_screen = false
      }
    },
    zoomPTrack (p) {
      if (this.mainParticipantsTrack) {
        this.participantsTracks.push(this.mainParticipantsTrack)
      }
      let currP = this.participantsTracks.findIndex(
        _p => _p.type === p.type && _p.id === p.id
      )
      this.participantsTracks.splice(currP, 1)
      setTimeout(() => {
        this.mainParticipantsTrack = null
      }, 20)
      setTimeout(() => {
        this.mainParticipantsTrack = p
      }, 30)
    },
    trackSubscribed (track, participant) {
      if (track.name === 'screen' + participant.sid) {
        if (this.mainParticipantsTrack) {
          this.participantsTracks.push(this.mainParticipantsTrack)
        }
        setTimeout(() => {
          let pt = {
            id: 'screen' + participant.sid,
            participant,
            tracks: [track],
            type: 'screen'
          }
          this.mainParticipantsTrack = pt
        }, 50)
      } else {
        let tracks = this.getTrackDiffScreens(participant)
        let p = this.participantsTracks.find(_p => _p.id === participant.sid)
        if (p) {
          p.tracks = tracks
        } else {
          let pt = {
            id: participant.sid,
            participant,
            tracks: tracks,
            type: 'normal'
          }
          this.participantsTracks.push(pt)
        }
      }
    },

    trackUnsubscribed (track, participant) {
      if (track.name === 'screen' + participant.sid) {
        if (
          this.mainParticipantsTrack &&
          this.mainParticipantsTrack.id === 'screen' + participant.sid
        ) {
          this.setMeToMain()
        } else {
          const p = this.participantsTracks.findIndex(
            _p => _p.id === 'screen' + participant.sid
          )
          this.participantsTracks.splice(p, 1)
        }
      } else {
        let p = null
        if (
          this.mainParticipantsTrack &&
          this.mainParticipantsTrack.participant.sid === participant.sid
        ) {
          p = this.mainParticipantsTrack
        } else {
          p = this.participantsTracks.find(_p => _p.id === participant.sid)
        }
        if (p) {
          const t = p.tracks.findIndex(_t => _t.name === track.name)
          p.tracks.splice(t, 1)
        }
      }
    },
    removeParticipant (participant) {
      if (
        this.mainParticipantsTrack &&
        this.mainParticipantsTrack.participant.sid === participant.sid
      ) {
        this.setMeToMain()
      }
      const filered = this.participantsTracks.filter(
        p => p.id !== participant.sid && p.id !== 'screen' + participant.sid
      )
      // if (this.mainParticipantsTrack && this.mainParticipantsTrack.participant.sid === participant.sid) {
      //   this.mainParticipantsTrack = null
      // }
      this.participantsTracks = filered
    },
    createLocalShare (stream) {
      if (this.mainParticipantsTrack) {
        this.participantsTracks.push(this.mainParticipantsTrack)
      }
      let pt = {
        id: 'screen' + this.room.localParticipant.sid,
        participant: this.room.localParticipant,
        tracks: [stream],
        type: 'screen'
      }
      this.mainParticipantsTrack = pt
    },
    isFirefox () {
      var mediaSourceSupport = !!navigator.mediaDevices.getSupportedConstraints()
        .mediaSource
      var matchData = navigator.userAgent.match('Firefox')
      var firefoxVersion = 0
      if (matchData && matchData[1]) {
        firefoxVersion = parseInt(matchData[1], 10)
      }
      return mediaSourceSupport && firefoxVersion >= 52
    },
    isChrome () {
      return 'chrome' in window
    },
    canScreenShare () {
      return this.isFirefox() || this.isChrome()
    },
    async getDoctorInfo (id) {
      let self = this
      let exitst = null
      if (self.member_joined && self.member_joined.length) {
        exitst = self.member_joined.find(d => d.id === id)
      }
      if (!exitst) {
        await self.$rf
          .getRequest('DoctorRequest')
          .getDoctorInfo(id)
          .then(r => {
            self.member_joined.push(r.data)
          })
      }
    },
    async getUserScreen () {
      if (!this.canScreenShare()) {
        alert('Trình duyệt của bạn không hỗ trợ tính năng này!')
        return
      }
      if (this.isChrome()) {
        return navigator.mediaDevices
          .getDisplayMedia()
          .then(stream => {
            return stream
          })
          .catch(e => {
            console.log(e)
          })
      } else if (this.isFirefox()) {
        return navigator.mediaDevices.getUserMedia({
          video: {
            mediaSource: 'screen'
          }
        })
      }
    },
    isArray (p) {
      return Array.isArray(p)
    },
    startTimeCount () {
      this.total_time = 0
      setTimeout(() => {
        this.start_count = setInterval(this.setTime, 1000)
      }, 30)
    },
    stopTimeCount () {
      clearInterval(this.start_count)
    },
    setTime () {
      this.total_time++
    },
    fancyTimeFormat (duration) {
      // Hours, minutes and seconds
      var hrs = ~~(duration / 3600)
      var mins = ~~((duration % 3600) / 60)
      var secs = ~~duration % 60

      // Output like "1:01" or "4:03:59" or "123:03:59"
      var ret = ''

      if (hrs > 0) {
        ret += '' + hrs + ':' + (mins < 10 ? '0' : '')
      }

      ret += '' + mins + ':' + (secs < 10 ? '0' : '')
      ret += '' + secs
      return ret
    },
    setMeToMain () {
      let myTracks = null
      let idsMyTracks = -1
      this.participantsTracks.some((pt, i) => {
        if (pt.id === this.room.localParticipant.sid) {
          myTracks = pt
          idsMyTracks = i
          return true
        }
        return false
      })
      if (myTracks) {
        this.mainParticipantsTrack = myTracks
        this.participantsTracks.splice(idsMyTracks, 1)
      } else {
        this.mainParticipantsTrack = this.participantsTracks[0]
        this.participantsTracks.splice(0, 1)
      }
    },
    createParticipantsTracks (p) {
      const pt = {
        id: p.sid,
        participant: p,
        tracks: this.getTrackDiffScreens(p),
        type: 'normal'
      }
      this.participantsTracks.push(pt)
    },
    formatTime (time) {
      return time
        ? window.moment.utc(time * 1000).format('HH:mm:ss')
        : '00:00:00'
    },
    backOrg () {
      this.$router.push({
        name: 'AppointmentDetail',
        params: { id: this.$route.params.id }
      })
    },
    saveComplete (data) {
      if (data) this.saveFile = data
    },
    backToCall () {
      this.connectRoom()
      this.logEnd = null
    },
    endCall () {
      this.$router.push({ name: 'AppointmentManagement' })
    },
    formatD (date_time) {
      return window.moment(date_time).format('DD/MM/YY')
    },
    openPDF (path) {
      let url = appUtils.getDocumentURL(path)
      window.open(url, '_blank').focus()
      window.event.stopPropagation()
    },
    handleShowFullScreen (isFull) {
      this.isFullScreen = isFull
    }
  },
  beforeDestroy () {
    this.disconnect()
  }
}
</script>

<style lang="scss" scoped>
.main-media {
  position: relative;
  width: 100%;
  height: 100%;
  background: #000;
  border-radius: 10px;
}
.appt-media-wraper {
  position: relative;
  width: 100%;
  aspect-ratio: 4 / 3;
}
.participant-media {
  position: absolute;
  width: 40%;
  bottom: 20px;
  right: 20px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.participant-media-item {
  min-height: 120px;

  // width: 30%;
  aspect-ratio: 16 / 9;
}
.loading {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
}
.spinner-border {
  width: 3rem;
  height: 3rem;
}

.bottom-action {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: 10px;
  left: 10px;
}
.scroll-end {
  height: 700px;
  overflow-y: scroll;
  overflow-x: hidden;
}
.bg-save-file {
  background-color: #ffd6c3;
}

.appt-media-wraper {
  position: relative;

  &:hover {
    .icon-fullscreen {
      display: block;
    }
  }
}

.icon-fullscreen {
  display: none;
  position: absolute;
  top: 10px;
  right: 15px;
  z-index: 3000;
}

.showFullScreen {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 2000;
  border-radius: unset !important;
  aspect-ratio: unset;
  padding: 0;
  background-color: #000;
  display: flex;
}

.media-fullscreen {
  width: 70%;
}

.participant-fullscreen {
  width: 30%;
  position: static !important;
  align-items: center;
  justify-content: center;
  margin-top: 40px;
  display: flex;
  flex-direction: column;
  padding: 10px;
}
</style>
